<div class="section-divider d-none d-md-flex align-items-center gap-3 mb-2">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🔥 {{ 'HEIZUNG_TITLE' | translate }}</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<div class="section-label d-flex align-items-center gap-2 mb-2 flex-wrap">
  <span class="badge bg-danger" style="font-size:.7rem;letter-spacing:.05em;"><span [style.opacity]="liveDotOn ? '1' : '0'">●</span> LIVE</span>
  <span class="fw-semibold small text-uppercase tracking-wide">{{ 'HEIZUNG_TITLE' | translate }}</span>
  <span *ngIf="froelingUpdatedAt" class="text-muted" style="font-size:.65rem;">· {{ updatedAgo(froelingUpdatedAt) }}</span>
  <div class="btn-group btn-group-sm ms-auto" role="group">
    <button *ngFor="let r of chartRanges" class="btn" style="font-size:.7rem;padding:1px 8px;"
            [ngClass]="range === r.key ? 'btn-secondary' : 'btn-outline-secondary'"
            (click)="setRange(r.key)">{{ r.label }}</button>
  </div>
  <span *ngIf="rangeLoading" class="spinner-border spinner-border-sm text-muted" role="status"></span>
  <button *ngIf="froelingHistory.length" class="btn btn-sm btn-outline-secondary" style="font-size:.7rem;padding:1px 8px;" (click)="openHeizungChart.emit()">📈</button>
</div>

<!-- Error banner -->
<div *ngIf="froeling && froeling.errors.length > 0" class="alert alert-danger py-2 px-3 mb-2 d-flex align-items-start gap-2" style="font-size:.8rem;">
  <span class="flex-shrink-0 mt-1">⚠️</span>
  <div>
    <div *ngFor="let err of froeling.errors" class="mb-1">
      <span class="fw-semibold">{{ err.code }}</span>
      <span>{{ err.message }}</span>
      <span *ngIf="err.timestamp" class="text-muted ms-1" style="font-size:.7rem;">{{ err.timestamp }}</span>
    </div>
  </div>
</div>

<!-- Expanded chart templates -->
<!-- Shared range selector, reused in every expanded chart overlay -->
<ng-template #rangeBar>
  <div class="btn-group btn-group-sm ms-auto" role="group">
    <button *ngFor="let r of chartRanges" class="btn" style="font-size:.7rem;padding:1px 8px;"
            [ngClass]="range === r.key ? 'btn-secondary' : 'btn-outline-secondary'"
            (click)="setRange(r.key)">{{ r.label }}</button>
  </div>
  <span *ngIf="rangeLoading" class="spinner-border spinner-border-sm text-muted ms-1" role="status"></span>
</ng-template>

<ng-template #boilerExpandedTpl>
  <div class="d-flex align-items-center gap-2 mb-1"><span class="fw-semibold small text-truncate" style="min-width:0;">🔥 {{ 'HEIZUNG_KESSEL_24H' | translate }}</span><ng-container *ngTemplateOutlet="rangeBar"></ng-container></div>
  <div style="aspect-ratio:16/9;">
    <canvas baseChart [data]="boilerExpandedData" [options]="boilerExpandedOptions" type="line"></canvas>
  </div>
</ng-template>

<ng-template #bufferExpandedTpl>
  <div class="d-flex align-items-center gap-2 mb-1"><span class="fw-semibold small text-truncate" style="min-width:0;">🛢️ {{ 'HEIZUNG_PUFFER_24H' | translate }}</span><ng-container *ngTemplateOutlet="rangeBar"></ng-container></div>
  <div style="aspect-ratio:16/9;">
    <canvas baseChart [data]="bufferExpandedData" [options]="bufferExpandedOptions" type="line"></canvas>
  </div>
</ng-template>

<ng-template #waterExpandedTpl>
  <div class="d-flex align-items-center gap-2 mb-1"><span class="fw-semibold small text-truncate" style="min-width:0;">🚿 {{ 'HEIZUNG_WARMWASSER_24H' | translate }}</span><ng-container *ngTemplateOutlet="rangeBar"></ng-container></div>
  <div style="aspect-ratio:16/9;">
    <canvas baseChart [data]="waterExpandedData" [options]="waterExpandedOptions" type="line"></canvas>
  </div>
</ng-template>

<ng-template #solarThermalExpandedTpl>
  <div class="d-flex align-items-center gap-2 mb-1"><span class="fw-semibold small text-truncate" style="min-width:0;">☀️ {{ 'HEIZUNG_SOLAR_24H' | translate }}</span><ng-container *ngTemplateOutlet="rangeBar"></ng-container></div>
  <div style="aspect-ratio:16/9;">
    <canvas baseChart [data]="solarThermalExpandedData" [options]="solarThermalExpandedOptions" type="line"></canvas>
  </div>
</ng-template>

<ng-template #outdoorExpandedTpl>
  <div class="d-flex align-items-center gap-2 mb-1"><span class="fw-semibold small text-truncate" style="min-width:0;">🌤️ {{ 'HEIZUNG_AUSSEN_24H' | translate }}</span><ng-container *ngTemplateOutlet="rangeBar"></ng-container></div>
  <div style="aspect-ratio:16/9;">
    <canvas baseChart [data]="outdoorExpandedData" [options]="outdoorExpandedOptions" type="line"></canvas>
  </div>
</ng-template>

<ng-template #pelletExpandedTpl>
  <div class="fw-semibold small mb-1">🪵 {{ 'HEIZUNG_PELLET_VERBRAUCH' | translate }} — {{ pelletConsumption24h | number:'1.0-0' }} kg / 24h</div>
  <div style="aspect-ratio:16/9;">
    <canvas baseChart [data]="pelletExpandedData" [options]="pelletExpandedOptions" type="bar"></canvas>
  </div>
</ng-template>

<ng-template #pumpExpandedTpl>
  <div class="d-flex align-items-center gap-2 mb-1"><span class="fw-semibold small text-truncate" style="min-width:0;">🔄 {{ 'HEIZUNG_PUMPE' | translate }}</span><ng-container *ngTemplateOutlet="rangeBar"></ng-container></div>
  <div style="aspect-ratio:16/9;">
    <canvas baseChart [data]="pumpExpandedData" [options]="pumpExpandedOptions" type="line"></canvas>
  </div>
</ng-template>

<div class="row g-2 g-sm-3 mb-3" *ngIf="froeling" [class.section-flash]="froelingFlash">

  <!-- Kessel / Boiler -->
  <div class="col-6 col-lg-3">
    <app-popup-card cardClass="h-100 border-danger" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="froelingHistory.length >= 2 ? boilerExpandedTpl : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">🔥</div>
            <div class="min-w-0 flex-grow-1">
              <div class="text-muted small">{{ 'HEIZUNG_KESSEL' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-danger text-truncate">{{ froeling.boilerTempC | number:'1.1-1' }} °C</div>
              <div class="text-muted text-truncate" style="font-size:.68rem;">
                <span *ngIf="froeling.boilerState">{{ boilerStateLabel(froeling.boilerState) }}</span>
                <span *ngIf="froeling.exhaustTempC"> · {{ 'HEIZUNG_ABGAS' | translate }} {{ froeling.exhaustTempC | number:'1.0-0' }}°</span>
              </div>
              <div *ngIf="froeling.boilerModulationPct" class="text-muted" style="font-size:.65rem;">
                {{ 'HEIZUNG_MOD' | translate }} {{ froeling.boilerModulationPct | number:'1.0-0' }}%
                <span *ngIf="froeling.returnTempC"> · {{ 'HEIZUNG_RL' | translate }} {{ froeling.returnTempC | number:'1.0-0' }}°</span>
              </div>
            </div>
          </div>
          <div *ngIf="froelingHistory.length >= 2" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="boilerChartData" [options]="boilerChartOptions" type="line"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>
  </div>

  <!-- Pufferspeicher / Buffer -->
  <div class="col-6 col-lg-3">
    <app-popup-card cardClass="h-100 border-primary" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="froelingHistory.length >= 2 ? bufferExpandedTpl : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">🛢️</div>
            <div class="min-w-0 flex-grow-1">
              <div class="text-muted small">{{ 'HEIZUNG_PUFFER' | translate }}</div>
              <div class="d-flex align-items-baseline gap-1">
                <div class="card-value fs-5 fw-bold text-primary text-truncate">{{ froeling.bufferTopTempC | number:'1.1-1' }}°</div>
                <span class="text-muted small">/</span>
                <span class="text-muted small">{{ froeling.bufferBottomTempC | number:'1.1-1' }}°</span>
              </div>
              <div *ngIf="froeling.bufferChargePct" class="mt-1">
                <div class="progress" style="height:5px;">
                  <div class="progress-bar"
                       [class.bg-success]="froeling.bufferChargePct >= 60"
                       [class.bg-warning]="froeling.bufferChargePct >= 30 && froeling.bufferChargePct < 60"
                       [class.bg-danger]="froeling.bufferChargePct < 30"
                       [style.width.%]="froeling.bufferChargePct"></div>
                </div>
                <div class="text-muted" style="font-size:.68rem;">{{ froeling.bufferChargePct }}% {{ 'HEIZUNG_GELADEN' | translate }}</div>
              </div>
            </div>
          </div>
          <div *ngIf="froelingHistory.length >= 2" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="bufferChartData" [options]="bufferChartOptions" type="line"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>
  </div>

  <!-- Heizkreise -->
  <div class="col-6 col-lg-3" *ngFor="let hc of froeling.heatingCircuits; let i = index">
    <app-popup-card cardClass="h-100 border-success" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="froelingHistory.length >= 2 && hcExpandedData[hc.name] ? hcExpandedTplRef : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">🌡️</div>
            <div class="min-w-0 flex-grow-1">
              <div class="text-muted small text-truncate">{{ hcLabel(hc.name) }}</div>
              <div class="d-flex align-items-baseline gap-1">
                <div class="card-value fs-5 fw-bold text-success text-truncate">{{ hc.flowTempActualC | number:'1.1-1' }}°</div>
                <span *ngIf="hc.flowTempTargetC" class="text-muted" style="font-size:.72rem;">/ {{ hc.flowTempTargetC | number:'1.0-0' }}° {{ 'HEIZUNG_SOLL' | translate }}</span>
              </div>
              <div *ngIf="hc.pumpState" class="text-muted" style="font-size:.68rem;">
                {{ 'HEIZUNG_PUMPE' | translate }}: {{ pumpLabel(hc.pumpState) }}
              </div>
            </div>
          </div>
          <div *ngIf="froelingHistory.length >= 2 && hcChartData[hc.name]" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="hcChartData[hc.name]" [options]="hcChartOptions" type="line"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>

    <ng-template #hcExpandedTplRef>
      <div class="fw-semibold small mb-1">🌡️ {{ hc.name }} (24h)</div>
      <div style="aspect-ratio:16/9;">
        <canvas baseChart [data]="hcExpandedData[hc.name]" [options]="hcExpandedOptions" type="line"></canvas>
      </div>
    </ng-template>
  </div>

  <!-- Warmwasser -->
  <div class="col-6 col-lg-3">
    <app-popup-card cardClass="h-100 border-info" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="froelingHistory.length >= 2 ? waterExpandedTpl : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">🚿</div>
            <div class="min-w-0 flex-grow-1">
              <div class="text-muted small">{{ 'HEIZUNG_WARMWASSER' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-info text-truncate">{{ froeling.hotWaterTempC | number:'1.1-1' }} °C</div>
            </div>
          </div>
          <div *ngIf="froelingHistory.length >= 2" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="waterChartData" [options]="waterChartOptions" type="line"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>
  </div>

  <!-- Zirkulationspumpe -->
  <div class="col-6 col-lg-3">
    <app-popup-card cardClass="h-100 border-primary" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="froelingHistory.length >= 2 ? pumpExpandedTpl : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">🔄</div>
            <div class="min-w-0 flex-grow-1">
              <div class="text-muted small">{{ 'HEIZUNG_ZIRKPUMPE' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-primary text-truncate">{{ froeling.circulationPumpPct | number:'1.0-0' }} %</div>
            </div>
          </div>
          <div *ngIf="froelingHistory.length >= 2" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="pumpChartData" [options]="pumpChartOptions" type="line"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>
  </div>

  <!-- Solarthermie -->
  <div class="col-6 col-lg-3" *ngIf="froeling.solarThermalTempC">
    <app-popup-card cardClass="h-100 border-warning" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="froelingHistory.length >= 2 ? solarThermalExpandedTpl : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">☀️</div>
            <div class="min-w-0 flex-grow-1">
              <div class="text-muted small">{{ 'HEIZUNG_SOLAR' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-warning text-truncate">{{ froeling.solarThermalTempC | number:'1.1-1' }} °C</div>
              <div *ngIf="froeling.solarThermalPumpPct" class="text-muted" style="font-size:.68rem;">
                {{ 'HEIZUNG_PUMPE' | translate }} {{ froeling.solarThermalPumpPct | number:'1.0-0' }}%
              </div>
            </div>
          </div>
          <div *ngIf="froelingHistory.length >= 2" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="solarThermalChartData" [options]="solarThermalChartOptions" type="line"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>
  </div>

  <!-- Außentemperatur (always shown — 0 °C is a legitimate freezing reading) -->
  <div class="col-6 col-lg-3">
    <app-popup-card cardClass="h-100" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="froelingHistory.length >= 2 ? outdoorExpandedTpl : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">🌤️</div>
            <div class="min-w-0">
              <div class="text-muted small">{{ 'HEIZUNG_AUSSEN' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-truncate"
                   [class.text-info]="froeling.outdoorTempC < 10"
                   [class.text-success]="froeling.outdoorTempC >= 10 && froeling.outdoorTempC < 25"
                   [class.text-warning]="froeling.outdoorTempC >= 25">
                {{ froeling.outdoorTempC | number:'1.1-1' }} °C
              </div>
            </div>
          </div>
          <div *ngIf="froelingHistory.length >= 2" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="outdoorChartData" [options]="outdoorChartOptions" type="line"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>
  </div>

  <!-- Pellets (always shown — an empty silo at 0% is exactly when this matters) -->
  <div class="col-6 col-lg-3">
    <app-popup-card cardClass="h-100" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="pelletStats.length > 0 ? pelletExpandedTpl : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">🪵</div>
            <div class="min-w-0 flex-grow-1">
              <div class="text-muted small">{{ 'HEIZUNG_PELLETS' | translate }}</div>
              <div class="d-flex align-items-baseline gap-1">
                <div class="card-value fs-5 fw-bold text-truncate"
                     [class.text-success]="froeling.pelletLevelPct >= 50"
                     [class.text-warning]="froeling.pelletLevelPct >= 20 && froeling.pelletLevelPct < 50"
                     [class.text-danger]="froeling.pelletLevelPct < 20">
                  {{ froeling.pelletLevelPct }}%
                </div>
                <span class="text-muted" style="font-size:.68rem;">· {{ froeling.pelletLevelPct * PELLET_CAPACITY_KG / 100 | number:'1.0-0' }} kg</span>
              </div>
              <div class="progress mt-1" style="height:5px;">
                <div class="progress-bar"
                     [class.bg-success]="froeling.pelletLevelPct >= 50"
                     [class.bg-warning]="froeling.pelletLevelPct >= 20 && froeling.pelletLevelPct < 50"
                     [class.bg-danger]="froeling.pelletLevelPct < 20"
                     [style.width.%]="froeling.pelletLevelPct"></div>
              </div>
              <div class="text-muted" style="font-size:.68rem;">
                <span *ngIf="pelletConsumption24h">{{ pelletConsumption24h | number:'1.0-0' }} kg / 24h</span>
                <span *ngIf="pelletConsumption24h"> · </span>
                {{ 'HEIZUNG_PELLET_LAGER' | translate }} {{ PELLET_CAPACITY_KG / 1000 | number:'1.0-0' }}t
              </div>
            </div>
          </div>
          <div *ngIf="pelletStats.length > 0" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="pelletChartData" [options]="pelletChartOptions" type="bar"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>
  </div>

</div>

<!-- Skeleton loader -->
<div *ngIf="!froeling" class="row g-2 g-sm-3 mb-3">
  <div class="col-6 col-lg-3" *ngFor="let _ of [0,1,2,3,4,5]">
    <div class="card h-100">
      <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
        <app-skeleton width="2rem" height="2rem" radius="6px" [darkMode]="darkMode" style="flex-shrink:0;"></app-skeleton>
        <div style="flex:1;min-width:0;">
          <app-skeleton width="60%" height=".75rem" radius="4px" [darkMode]="darkMode" style="display:block;margin-bottom:6px;"></app-skeleton>
          <app-skeleton width="80%" height="1.4rem" radius="4px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>

